module.exports = __webpack_public_path__ + "static/media/doubleDoor270.ce0d34a1.png";